import { get, post, put, del, getPage } from '@/utils/request'
import type { TimerSchedule, TimerRun, TimerTargetOption } from '@/types'

/** 通用定时器：定时计划列表 */
export function listSchedules(params: {
  project_id: number
  target_type?: string
  keyword?: string
  page?: number
  page_size?: number
}) {
  return getPage<TimerSchedule>('/timers/schedules', params)
}

/** 通用定时器：创建定时计划 */
export function createSchedule(data: {
  project_id: number
  target_type: string
  target_id: number
  name: string
  cron_expr: string
  enabled?: boolean
}) {
  return post<TimerSchedule>('/timers/schedules', data)
}

/** 通用定时器：更新定时计划 */
export function updateSchedule(
  id: number,
  projectId: number,
  data: { name?: string; cron_expr?: string; enabled?: boolean }
) {
  return put<TimerSchedule>(`/timers/schedules/${id}`, data, { params: { project_id: projectId } })
}

/** 通用定时器：启用/停用定时计划 */
export function setScheduleEnabled(id: number, projectId: number, enabled: boolean) {
  return put<TimerSchedule>(`/timers/schedules/${id}/enabled`, null, {
    params: { project_id: projectId, enabled },
  })
}

/** 通用定时器：删除定时计划 */
export function deleteSchedule(id: number, projectId: number) {
  return del(`/timers/schedules/${id}`, { params: { project_id: projectId } })
}

/** 通用定时器：可选执行目标（接口场景 + UI 用例） */
export function listTargets(projectId: number) {
  return get<{ scenario: TimerTargetOption[]; ui_script: TimerTargetOption[] }>('/timers/targets', {
    project_id: projectId,
  })
}

/** 通用定时器：定时器执行记录列表 */
export function listRuns(params: {
  project_id: number
  schedule_id?: number
  status?: number
  target_type?: string
  page?: number
  page_size?: number
}) {
  return getPage<TimerRun>('/timers/runs', params)
}
